// Opções estáticas dos gráficos Apex — séries e categorias vêm da API (dashboards/*)

export const BarHorizontalOptions = {
  chart: {
    type: "bar",
    height: 320,
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: true,
      columnWidth: "60%",
      borderRadius: 4,
    },
  },
  colors: ["#00c9ff", "#fdaf22"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 1,
    colors: ["#fff"],
  },
  grid: {
    borderColor: "#f2f5f7",
  },
  xaxis: {
    categories: [],
    labels: {
      show: true,
      style: {
        colors: "#8c9097",
        fontSize: "11px",
        fontWeight: 600,
      },
    },
  },
  yaxis: {
    labels: {
      show: true,
      style: {
        colors: "#8c9097",
        fontSize: "11px",
        fontWeight: 600,
      },
    },
  },
  tooltip: {
    shared: true,
    intersect: false,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
  },
};

export const ColumnRedeOptions = {
  chart: {
    type: "bar",
    height: 320,
    toolbar: { show: false },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "60%",
      borderRadius: 4,
    },
  },
  colors: ["#32d484", "#fdaf22"],
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 2,
    colors: ["transparent"],
  },
  grid: {
    borderColor: "#f2f5f7",
  },
  xaxis: {
    categories: [],
    labels: {
      show: true,
      style: {
        colors: "#8c9097",
        fontSize: "11px",
        fontWeight: 600,
      },
    },
  },
  yaxis: {
    labels: {
      show: true,
      style: {
        colors: "#8c9097",
        fontSize: "11px",
        fontWeight: 600,
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: true,
    position: "top",
    horizontalAlign: "left",
  },
};

export const DonutListaOptions = {
  chart: {
    type: "donut",
    height: 290,
    toolbar: { show: false },
  },
  labels: [],
  colors: ["#0ca3e7", "#fdaf22", "#8c9097", "#cd7f32", "#32d484"],
  legend: {
    position: "bottom",
  },
  dataLabels: {
    enabled: true,
    dropShadow: { enabled: false },
    formatter: function (val) {
      return val.toFixed(1) + "%";
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + " nomes";
      },
    },
  },
  plotOptions: {
    pie: {
      donut: {
        size: "60%",
        labels: {
          show: true,
          total: {
            show: true,
            label: "Total",
            formatter: function (w) {
              return w.globals.seriesTotals.reduce(function (a, b) {
                return a + b;
              }, 0);
            },
          },
        },
      },
    },
  },
};

export const DonutMesOptions = {
  chart: {
    type: "donut",
    height: 290,
    toolbar: { show: false },
  },
  labels: [],
  colors: ["#0ca3e7", "#fdaf22", "#8c9097", "#cd7f32", "#32d484"],
  legend: {
    position: "bottom",
  },
  dataLabels: {
    enabled: true,
    dropShadow: { enabled: false },
    formatter: function (val) {
      return val.toFixed(1) + "%";
    },
  },
  tooltip: {
    y: {
      formatter: function (val) {
        return val + " nomes";
      },
    },
  },
  plotOptions: {
    pie: {
      donut: {
        size: "60%",
        labels: {
          show: true,
          total: {
            show: true,
            label: "Total",
            formatter: function (w) {
              return w.globals.seriesTotals.reduce(function (a, b) {
                return a + b;
              }, 0);
            },
          },
        },
      },
    },
  },
};
